<div class="wrapper">
  <cs-icon-button
    class="btn-close"
    iconType="icon"
    icon="fi-x"
    color="secondary"
    size="12"
    (buttonClick)="closeBetDetails()"
  ></cs-icon-button>

  <div class="heading">Bet Details</div>

  <div class="scroll-cont">
    <div class="cont">
      <div class="row">
        <img
          #gameLogoImg
          class="game-img"
          alt="GAME IMG"
          [src]="data.gameLogoImgSrc"
          (error)="gameLogoImg.src = errorImg"
          loading="lazy"
        />
        <div class="bet-details column">
          <div class="item">
            <div class="tt">Bet</div>
            <div class="text">
              <cs-currency-converter [amount]="data.betAmount" [currency]="data.currency" />
              <cs-currency-unit-display [currency]="data.currency" [iconSize]="16" />
            </div>
          </div>
          <div class="item">
            <div class="tt">Payout</div>
            <div [ngClass]="{ text: true, mark: data.payAmount > 0 }">
              <cs-currency-converter [amount]="data.payAmount" [currency]="data.currency" />
              <cs-currency-unit-display [currency]="data.currency" [iconSize]="16" />
            </div>
          </div>
          <div class="item">
            <div class="tt">Multiplier</div>
            <div class="text big">{{ data.multiplier || '-' }}</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div [style.overflow]="'hidden'">
          <div class="game-name">{{ data.gameName }}</div>
          <div class="game-provider" *ngIf="!isSportBet">By {{ data.gameProviderName || 'Unknown Provider' }}</div>
        </div>
      </div>
      <div class="row">
        <div class="bet-details">
          <div class="item">
            <div class="tt">Placed by</div>
            <div class="text">
              @if (!data.playerName) {
                <i class="fi-incognito-filled"></i>
              }
              {{ data.playerName || ('invisible' | translate) }}
            </div>
          </div>
          <!-- ALL-12262 remove timestamp -->
          <!-- <div class="item">
            <div class="tt">On</div>
            <div class="text">{{ data.dateTime | mdate: 'DD/MM/YYYY HH:mm:ss' }}</div>
          </div> -->
        </div>
      </div>
      <div class="row">
        <cs-button
          [label]="data.isSportBet ? 'Go to Sports' : 'Play Game'"
          color="primary"
          size="large"
          (buttonClick)="clickGameItem(data)"
        ></cs-button>
      </div>
    </div>

    @if (data.otherDetailsStatus || data.otherDetailsBetId || data.otherDetailsType) {
      <div class="other-details">
        <h6>Other details</h6>
        <div class="other-details-container">
          <div>
            <label>Status</label>
            <div>
              <span>{{ data.otherDetailsStatus }}</span>
            </div>
          </div>
          <div>
            <label>Bet ID</label>
            <div>
              <span>{{ data.otherDetailsBetId }}</span>
              <i class="fi-clipboard" (click)="copyBetId(data.otherDetailsBetId || '')"></i>
            </div>
          </div>
          <div>
            <label>Type</label>
            <div>
              <span>{{ data.otherDetailsType }}</span>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>
